import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, X, ArrowRight } from 'lucide-react'
import { MobileNav } from './MobileNav'
import { NavDropdown } from './NavDropdown'
import { navGroups, pricingLink } from '@/data/navigation'

export function Header() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <header className="border-primary sticky top-0 z-40 w-full border-b bg-gray-950/90 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4">
          <Link to="/" className="text-foreground flex flex-shrink-0 items-center gap-2.5">
            <img src="/logo-mark.svg" alt="" aria-hidden="true" className="h-9 w-auto" />
            <span className="text-3xl font-bold tracking-tight">Fugue Lab</span>
          </Link>

          {/* Desktop nav */}
          <nav aria-label="Main" className="hidden items-center gap-x-6 lg:flex">
            {navGroups.map((group) => (
              <NavDropdown key={group.label} label={group.label} items={group.items} footer={group.footer} />
            ))}
            <Link to={pricingLink.href} className="text-muted-foreground hover:text-foreground text-sm transition">
              {pricingLink.label}
            </Link>
            <Link
              to="/get-started"
              className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex items-center justify-center gap-1.5 rounded-md px-5 py-2 text-sm font-medium transition"
            >
              Get Started <ArrowRight className="h-4 w-4" />
            </Link>
          </nav>

          {/* Mobile toggle */}
          <div className="lg:hidden">
            <button onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu">
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </header>

      <MobileNav isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  )
}
